module.exports = __webpack_public_path__ + "static/media/GroupIcon.18b963a5.svg";